import {ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel} from "../../../shared";

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { MessageContainer } from "../../../../../../../models/mongodbSchema/aggregates";

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MessageService extends BaseApiTemplateService<MessageContainer> {

  constructor(private http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    this.httpClient = http;
  }

    public setUrl(conversationId, apiVisa: ApiVisa) {
      let baseUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';

      this.apiUrl = Core2Config.DOMAIN_URL + baseUrl + `/${conversationId}/message`;
      this.endpoint_path = baseUrl + `/${conversationId}/message`;
  }


  public getMessagesBetweenSnapshot(conversationId: string, pagination: Pagination, apiVisa: ApiVisa) {
    const baseUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    const url = baseUrl + `/${conversationId}/message/between-snapshot` + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MessageContainer>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

  public getMessagesBySearch(pagination: Pagination, apiVisa: ApiVisa) {
    const baseUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    const url = baseUrl + `/text-search` + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

  public getMessagesBySearchCount(pagination: Pagination, apiVisa: ApiVisa) {
    const baseUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    const url = baseUrl + `/text-search/count` + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<Number>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

  public fetchMedia(conversationId: string, messageId: string, apiVisa: ApiVisa) {
    const baseUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    const url = baseUrl + `/${conversationId}/message/${messageId}/media`;

       return this.httpClient.get(url, {
          responseType: 'blob', // This is fine, but we need error handling
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'tenant-code': apiVisa.tenantCode,
            'token': apiVisa.jwt_secret
          })
        }).pipe(
            catchError(error => {
              if (error.status === 400) {
                return error.error.text ? this.handleBlobError(error.error) : throwError(() => error);
              }
              return throwError(() => error);
            })
        );
  }

  private handleBlobError(blob: Blob): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const errorJson = JSON.parse(reader.result as string);
          observer.error(errorJson);
        } catch (e) {
          observer.error({ message: "Unknown error", details: e });
        }
      };
      reader.onerror = () => {
        observer.error({ message: "Error reading error response" });
      };
      reader.readAsText(blob);
    });
  }
}
